import Stack from '@mui/material/Stack'

import { ReactComponent as LinedCardZeroStateSVG } from '../images/LinedCardZeroState.svg'
import { ThemedSVGImage } from '../ThemedSVGImage'

const imageStyles = {
  padding: 8,
  marginTop: 8,
  marginBottom: 12,
}

export const LinedCardZeroState = () => (
  <Stack
    sx={{
      flexDirection: 'row',
      justifyContent: 'center',
    }}
  >
    <ThemedSVGImage divProps={{ style: imageStyles }} image={LinedCardZeroStateSVG} />
  </Stack>
)
